import React, { Component } from "react";
import PageSection from "../../Controls/PageSection";
import Page from "../../Controls/Page";
import Input from "../../Controls/Input"; // Add this import

class CredentialVerify extends Component {
  constructor(props) {
    super(props);

    // Get params from props.location.state (passed from parent/route)
    const state = this.props.location && this.props.location.state ? this.props.location.state : {};
    const mode = state && state.hasOwnProperty('mode') ? state.mode : "";
    const provider = state && state.hasOwnProperty('provider') ? state.provider : "";
    const registrationId = state && state.hasOwnProperty('registrationId') ? state.registrationId : "";
    const _id = state && state.hasOwnProperty('_id') ? state._id : "";
    const credentials = state && state.hasOwnProperty('credentials') ? state.credentials : {};

    this.state = {
      mode: mode,
      provider: provider,
      registrationId: registrationId,
      _id: _id,
      loading: false,
      formData: {
        senderId: credentials && credentials.hasOwnProperty('senderId') ? credentials.senderId : "",
        apiKey: (credentials && credentials.hasOwnProperty('apiKey') ? credentials.apiKey : (credentials && credentials.hasOwnProperty('apikey') ? credentials.apikey : "")),
        appId: (credentials && credentials.hasOwnProperty('appId') ? credentials.appId : (credentials && credentials.hasOwnProperty('appName') ? credentials.appName : "")),
        accountSID: (credentials && credentials.hasOwnProperty('accountSID') ? credentials.accountSID : (credentials && credentials.hasOwnProperty('secret') ? credentials.secret : "")),
        authToken: (credentials && credentials.hasOwnProperty('authToken') ? credentials.authToken : (credentials && credentials.hasOwnProperty('phone') ? credentials.phone : "")),
        instanceId: credentials && credentials.hasOwnProperty('instanceId') ? credentials.instanceId : "",
        accessToken: credentials && credentials.hasOwnProperty('accessToken') ? credentials.accessToken : "",
        authKey: credentials && credentials.hasOwnProperty('authKey') ? credentials.authKey : "",
      }
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  handleChange(field, value) {
    this.setState((prevState) => ({
      formData: Object.assign({}, prevState.formData, { [field]: value })
    }));
  }

  handleCancel() {
    this.props.history.goBack();
  }

  async handleSubmit(e) {
    if (e) e.preventDefault();

    const formData = this.state.formData;
    const provider = this.state.provider;
    const mode = this.state.mode;
    const registrationId = this.state.registrationId;
    const _id = this.state._id;

    // Dynamically construct the credentials object based on the provider
    const payloadCredentials = {
      senderId: formData.senderId,
    };

    if (provider === "AiSensy") {
      payloadCredentials.apiKey = formData.apiKey;
      payloadCredentials.instanceId = formData.instanceId;
    } else if (provider === "Gupshup") {
      payloadCredentials.apiKey = formData.apiKey;
      payloadCredentials.appId = formData.appId;
    } else if (provider === "Twilio") {
      payloadCredentials.accountSID = formData.accountSID;
      payloadCredentials.authToken = formData.authToken;
    }
    else if (provider === "Meta") {
      payloadCredentials.accessToken = formData.accessToken;
    }
    else if (provider && provider.toLowerCase() === "cpaas") {
      console.log(formData, "form data");
      payloadCredentials.authKey = formData.authKey;
    }

    console.log(payloadCredentials, "payload");

    this.setState({ loading: true });

    try {
      if (mode === "edit") {
        const data = await this.props.updateCredentials(_id, payloadCredentials);
        console.log(data, "update data ");
        if (data.code === "0") {
          this.props.getToastr("Credential updated successfully");
        }
      } else {
        const data = await this.props.setupCredentials(
          payloadCredentials,
          registrationId,
          provider
        );
        console.log(data, "saved data ");
        if (data.code === "0") {
          this.props.getToastr("Credential saved successfully");
        }
      }

      this.props.history.push("/home/integration");
    } catch (error) {
      console.error("API error:", error);
      alert(
        "Something went wrong. Please check your credentials and try again."
      );
    } finally {
      this.setState({ loading: false });
    }
  }

  render() {
    const provider = this.state.provider;
    const formData = this.state.formData;

    return (
      <Page
        title={provider + " Credentials"}
        showSaveButton={true}
        showCancelButton={true}
        processing={this.state.loading}
        onClick={(action) => {
          if (action === "cancel") {
            this.handleCancel();
          } else if (action === "save") {
            this.handleSubmit();
          }
        }}
      >
        <PageSection>
          <form onSubmit={this.handleSubmit} className="space-y-5">
            {/* Common Sender ID Field */}
            {(provider !== "Posible" && provider && provider.toLowerCase() !== "cpaas") && (
              <Input
                type="text"
                label="Sender ID (Sender Number)"
                placeholder="Enter Sender ID"
                value={formData.senderId}
                onChange={(value) => this.handleChange("senderId", value)}
                required={true}
                error={!formData.senderId && this.state.submitted ? "Sender ID is required" : ""}
              />
            )}

            {provider === "Posible" && (
              <div className="bg-gradient-to-r from-indigo-50 to-purple-50 p-6 rounded-2xl shadow-xl border border-indigo-200 mb-8">
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 text-4xl mt-1">🚀</div>
                  <div>
                    <h3 className="text-2xl font-extrabold text-indigo-800 mb-2">
                      Instant WhatsApp Integration: Enable with Posible!
                    </h3>

                    <p className="text-gray-700 mb-4 text-lg">
                      Looking for the fastest way to get your WhatsApp messaging
                      live? Use our
                      <strong className="text-purple-600">
                        {" "}
                        One-Click Posible Setup
                      </strong>
                      . It's designed for users who want to avoid complex
                      configuration and start communicating{" "}
                      <em className="font-semibold">right now</em>.
                    </p>

                    <div className="bg-white p-4 rounded-xl shadow-inner border border-purple-100">
                      <p className="font-bold text-xl text-red-600 mb-2 flex items-center">
                        <span className="mr-2">⚠️</span> Important Considerations:
                      </p>
                      <ul className="list-disc list-inside ml-4 space-y-2 text-gray-700">
                        <li>
                          <strong className="text-indigo-700">Branding:</strong>{" "}
                          Messages sent to your clients will originate from a
                          WhatsApp Business Number managed by{" "}
                          <span className="font-extrabold text-purple-600">
                            Posible
                          </span>
                          . This may affect your direct brand recognition.
                        </li>
                        <li>
                          <strong className="text-indigo-700">
                            Cost & Setup:
                          </strong>{" "}
                          The initial setup is{" "}
                          <span className="font-bold text-green-600">
                            totally FREE
                          </span>
                          ! However, message costs will be calculated and billed
                          based on your actual volume of messages (per
                          conversation) sent and received.
                        </li>
                      </ul>
                    </div>

                    <p className="mt-4 text-lg text-indigo-700 font-semibold">
                      If you accept these terms, simply select the{" "}
                      <strong className="text-purple-600">"Posible"</strong>{" "}
                      provider card below to activate in a single click!
                    </p>
                  </div>
                </div>
              </div>
            )}
            
            {/* AiSensy Specific Fields */}
            {provider === "AiSensy" && (
              <React.Fragment>
                <Input
                  type="text"
                  label="API Key"
                  placeholder="Enter AiSensy API Key"
                  value={formData.apiKey}
                  onChange={(value) => this.handleChange("apiKey", value)}
                  required={true}
                  error={!formData.apiKey && this.state.submitted ? "API Key is required" : ""}
                />
                <Input
                  type="text"
                  label="Instance ID"
                  placeholder="Enter AiSensy Instance ID"
                  value={formData.instanceId}
                  onChange={(value) => this.handleChange("instanceId", value)}
                  required={true}
                  error={!formData.instanceId && this.state.submitted ? "Instance ID is required" : ""}
                />
              </React.Fragment>
            )}

            {/* CPaas Specific Fields */}
            {provider && provider.toLowerCase() === "cpaas" && (
              <React.Fragment>
                <Input
                  type="text"
                  label="Auth Key"
                  placeholder="Enter CPaas Auth Key"
                  value={formData.authKey}
                  onChange={(value) => this.handleChange("authKey", value)}
                  required={true}
                  error={!formData.authKey && this.state.submitted ? "Auth Key is required" : ""}
                />
              </React.Fragment>
            )}

            {/* Gupshup Specific Fields */}
            {provider === "Gupshup" && (
              <React.Fragment>
                <Input
                  type="text"
                  label="API Key"
                  placeholder="Enter Gupshup API Key"
                  value={formData.apiKey}
                  onChange={(value) => this.handleChange("apiKey", value)}
                  required={true}
                  error={!formData.apiKey && this.state.submitted ? "API Key is required" : ""}
                />
                <Input
                  type="text"
                  label="App ID"
                  placeholder="Enter Gupshup App ID"
                  value={formData.appId}
                  onChange={(value) => this.handleChange("appId", value)}
                  required={true}
                  error={!formData.appId && this.state.submitted ? "App ID is required" : ""}
                />
              </React.Fragment>
            )}

            {/* Twilio Specific Fields */}
            {provider === "Twilio" && (
              <React.Fragment>
                <Input
                  type="text"
                  label="Account SID"
                  placeholder="Enter Twilio Account SID"
                  value={formData.accountSID}
                  onChange={(value) => this.handleChange("accountSID", value)}
                  required={true}
                  error={!formData.accountSID && this.state.submitted ? "Account SID is required" : ""}
                />
                <Input
                  type="password"
                  label="Auth Token"
                  placeholder="Enter Twilio Auth Token"
                  value={formData.authToken}
                  onChange={(value) => this.handleChange("authToken", value)}
                  required={true}
                  error={!formData.authToken && this.state.submitted ? "Auth Token is required" : ""}
                />
              </React.Fragment>
            )}

            {/* Meta Specific Fields */}
            {provider === "Meta" && (
              <React.Fragment>
                <Input
                  type="text"
                  label="ACCESS_TOKEN"
                  placeholder="Enter Meta Access Token"
                  value={formData.accessToken}
                  onChange={(value) => this.handleChange("accessToken", value)}
                  required={true}
                  error={!formData.accessToken && this.state.submitted ? "Access Token is required" : ""}
                />
              </React.Fragment>
            )}
          </form>
        </PageSection>
      </Page>
    );
  }
}

export default CredentialVerify;